import { EditGenericProduct } from './EditGenericProduct'

export default EditGenericProduct
